import { notification } from "@aksara-ui/react";

export const showMessage = (message: string, type: any) => {
  notification.toaster({
    message: message,
    status: type,
    dismissible: true,
    dismissAfter: 5000,
  });
};
